import { menuRouteArr, constantRoutes } from '@/router';

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role));
  }
  return true;
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = [];

  routes.forEach((route) => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  return res;
}
// 以下三个方法是用来过滤路由菜单权限的
// 分析数据-2
/* eslint-disable */
function getChildren(array, resMap, name, concat) {
  const cc = [];
  array.forEach((it1) => {
    if (it1.children && it1.children.length > 0) {
      getChildren(it1.children, resMap, it1.path, concat);
    } else {
      if (concat && resMap[`${name + it1.path}`]) {
          cc.push(it1);
      } else {
        resMap[`${name + it1.path}`] = true;
      }
    }
  });
  return cc;
}

// 分析数据-1
function loadCom(authRoute) {
  const resMap = {};
  if(authRoute){
    authRoute.forEach((it1) => {
      resMap[it1.path] = true;
      if (it1.children) {
        getChildren(it1.children, resMap, it1.path);
      }
    });
    return resMap;
  }
}

// 合并数据
function concatAuth(authRoute) {
  const resMap = loadCom(authRoute);
  const c = [];
  menuRouteArr.forEach((it1) => {
    const { path } = it1;
    // 权限是否在存在
    if (resMap!=undefined&&resMap[path]) {
      if (it1.children) {
        it1.children = getChildren(it1.children, resMap, path, 1);
        c.push(it1);
      }
    }
  });
  return c;
}

const state = {
  routes: [],
  addRoutes: [],
};

const mutations = {
  SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
};

const actions = {
  generateRoutes({ commit }) {
    return new Promise((resolve) => {
      const authRoute = JSON.parse(localStorage.getItem("authRoute"));
      loadCom(authRoute);
      const asyncRoutes = concatAuth(authRoute);
      const accessedRoutes = asyncRoutes || [];
      
      commit('SET_ROUTES', accessedRoutes);
      resolve(accessedRoutes);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
